import './index.css'
import Button from '../button';
import { StructureIdea } from '../../functions/structureIdea';
import { fetchStructuredIdea } from '../../functions/fetchStructureIdea';
import { useState } from 'react';

function PostIdea({date,generatedFrom,content,status,id,display,expandIdea,SetExpandedIdea,handleDeleteRequest,scheduledDate,ideaType,image}){
    let statusMessage;
    let statusGraph;
    let CTA;
    switch (status){
        case 1:
            statusMessage='Generated';
            statusGraph=<><div class="status-widget complete"></div><div class="status-widget"></div></>;
            CTA='View post'
        break;
        case 3:
            let dateParts = scheduledDate.split(' ');
            let formattedDateString = `${dateParts[2]} ${dateParts[1]} ${dateParts[3]}`; // Convert to '02 Oct 2024' format
            let dateToDisplay = new Date(formattedDateString);
            statusMessage = dateToDisplay.toLocaleDateString();
            statusGraph=<><div class="status-widget complete"></div><div class="status-widget complete"></div></>;
            CTA='View post'
        break;
        
    }

    let displayToSet;
    if(display==='none'){
        displayToSet='flex'
    }
    else{
        displayToSet='none'
    }

    const handleOpenIdea = async(id) => {
        let ideaStructure = {
            "id": id,
            "title": `${generatedFrom}`,
            "generatedFrom": generatedFrom,
            "stage": status,
            "structure": content,
            "scheduledDate": scheduledDate,
            "ideaType": "post",
            "image" : image
        }
           await SetExpandedIdea(ideaStructure);
           expandIdea()
    }

    return <div className='idea-item-border post-idea' style={{display:displayToSet}}>
    <div className='idea-item idea'>
    <div className='idea-info-holder'>
    <div className='tiny-text date'>{new Date(date).toDateString()}</div>
    <img className='idea-type-tag' src='../images/linkedin.png'></img>    </div>
    <div className='post-title-holder'><h2>{generatedFrom}</h2></div>
    <div className='info-holder'>
    <div className='status-holder tiny-text'>
        <div className='label'>Status</div>
        <div className='status-graph-holder'>
            {statusGraph}
        </div>
        <div className='value'>{statusMessage}</div>
    </div>
    </div>
    <div className='idea-action-bar'>
    <Button text={CTA} smallBool={true} addedFunction={handleOpenIdea} params={id}/>
    <Button text='Delete' smallBool={true} addedFunction={handleDeleteRequest} params={id}></Button>
    </div>
    </div>
    </div>
}

export default PostIdea